import React from "react";
import {
    createNewPayment,
    populatePayment,
    removePayment,
    resetData,
    updateTotals
} from '../lib/payment-utils';
import {sendGoogleAnalyticsEvent} from '../lib/utils';

import defaultComponents from '../components/default-components';

class OnePagePayment extends React.Component {
    constructor(props) {
        super(props);
        // callbacks for operations on payment
        // add/remove/update
        this.addPayment = this.addPayment.bind(this);
        this.handleValidAccount = this.handleValidAccount.bind(this);
        this.populatePaymentFromCif = this.populatePaymentFromCif.bind(this);
        // Call this method to prepare dialog to remove account
        this.removePaymentAsk = this.removePaymentAsk.bind(this);
        this.removePaymentConfirmed = this.removePaymentConfirmed.bind(this);
        this.closeRemoveDlg = this.closeRemoveDlg.bind(this);
        this.acceptPayment = this.acceptPayment.bind(this);
        this.acceptPaymentCancel = this.acceptPaymentCancel.bind(this);
        this.cancelPaymentAsk = this.cancelPaymentAsk.bind(this);
        this.cancelPaymentConfirmed = this.cancelPaymentConfirmed.bind(this);
        this.closeCancelDlg = this.closeCancelDlg.bind(this);
        this.makeAnotherPaymentDiffCustomer = this.makeAnotherPaymentDiffCustomer.bind(this);

        this.appComponents = {...defaultComponents, ...props.appComponents};
    }

    removePaymentAsk(payment) {
        const {state} = this.props;
        state.setValue('removeDlgPayment', payment);
    }

    removePaymentConfirmed(index) {
        const {state} = this.props,
            {config} = state;
        state.setValues((data) => {
            removePayment(data, config, index);
            updateTotals(data);
            return data;
        });
    }

    closeRemoveDlg() {
        const {state} = this.props;
        state.setValues((data) => {
            delete data.removeDlgPayment;
            return data;
        });
    }

    cancelPaymentAsk() {
        const {state} = this.props;
        state.setValue('cancelDlgPayment', true);
    }

    cancelPaymentConfirmed() {
        const {state} = this.props,
            {config} = state,
            {messages} = config;

        sendGoogleAnalyticsEvent('Payment', messages["ga.event.action.resetPayment"] || 'Clicked Reset Payment', config.gaEventLabel);

        state.setValues((data) => {
            resetData(data, config);
            return data;
        });
    }

    closeCancelDlg() {
        const {state} = this.props;
        state.setValues((data) => {
            delete data.cancelDlgPayment;
            return data;
        });
    }

    handleValidAccount(payment) {
        const {state} = this.props,
            {data} = state;

        // identify payment int the list and update the list
        const payments = data.payments,
            idx = payments.findIndex(p => p && p.index === payment.index);

        if (idx === -1) {
            return;
        }

        if (!this.populatePaymentFromCif(payment, idx)){
            return;
        }
        // check if we need to show the recent payments dialog
        let showRecent = (payment.recentPayments && payment.recentPayments.length > 0);
        if (showRecent) {
            // show payment history modal
            state.setValues((data) => {
                data.accountWithRecentPayments = payment;
                return data;
            });
            return;
        }
        // active flag activates payment info section
        payment.active = true;
        state.setValues((data) => {
            return data;
        });
    }

    populatePaymentFromCif(payment, idx) {
        const {state} = this.props;
        // accountInfoResponse should be populated by ajax call
        this.appComponents.populatePayment(payment, payment.accountInfoResponse);
        //TODO do we need this? The java validator and/or RT ms should validate everything?
        //TODO this code seems out of place, we can remove this validation if we refactor alfa code
        if (this.appComponents.validatePopulatedPayment && typeof this.appComponents.validatePopulatedPayment === 'function') {
            let errors = this.appComponents.validatePopulatedPayment(payment, idx);
            if (errors && errors.length > 0) {
                // update the state with the error to display on the page
                errors.forEach(error => {
                    state.setErrors({
                            [error.field]: error.value
                        }
                    )
                })
                return false;
            }
        }
        return true;
    }

    acceptPayment(index) {
        const {state} = this.props;
        state.setValues((data) => {
            data.accountWithRecentPayments = null;
            return data;
        });
    }

    acceptPaymentCancel() {
        const {state} = this.props;
        state.setValues((data) => {
            data.accountWithRecentPayments = null;
            return data;
        });
    }

    addPayment() {
        const {state} = this.props,
            {config} = state;
        state.setValues((data) => {
            data.payments.push(createNewPayment(data, config));
            return data;
        });
    }

    makeAnotherPaymentDiffCustomer() {
        const {state} = this.props,
            {config} = state;
        state.setValues((data) => {
            resetData(data, config);
            return data;
        });
        state.resetErrors();
    }

    render() {
        const state = this.props.state,
            {data, config, setValues, setValue} = state,
            {
                // fields we will use for sections
                payments, customer, paymentMethod,
                // fields needed for remove payment dialog
                removeDlgPayment, cancelDlgPayment,
                // state fields to show accept dialog
                accountWithRecentPayments
            } = data,
            {paymentConfig, messages, tla, xotpUser, jwt} = config;

        // create a simplified model with the read only fields

        // at this time we only have account info sections for each payment
        let removeEnabled = payments.length > 1;

        // Active payments are accounts that had been validated and liability info
        // and last used payment method information had been read.
        const allPaymentsValidated = payments.reduce((ac, p) => ac && p.active, true),
            hasActivePayments = payments.reduce((ac, p) => ac || p.active, false),
            paymentPreferenceEnabled = paymentConfig.paymentPreferenceEnabled,
            sectionIconEnabled = paymentConfig.oppSectionIconEnabled;


        const {
            AccountInfo,
            AccountAddSection,
            PaymentInfo,
            ContactInfoSection,
            PaymentMethodInfo,
            PaymentPreferenceSection,
            ReviewPayment,
            Receipt,
            RoppPageWrapper,
            DeleteDialog,
            CancelDialog,
            AcceptAccountDialog,
            postProcessSuccessfulPayment
        } = this.appComponents;

        // Generate list of elements where each element will have a unique key
        // generated to let React.js do his magic of updated the DOM.
        let reactElements = [];
        if (!data.showReceipt) {
            payments.map((payment, idx) => {
                const fieldPrefix = `payments[${idx}].header`;
                // After account is validated, payment record becomes active, enables
                // the payment info section, but lock down the account info section
                reactElements.push(
                    <AccountInfo
                        key={"AccountInfo-" + payment.index}
                        idx={idx}
                        payment={payment}
                        onValidAccount={this.handleValidAccount}
                        onRemove={this.removePaymentAsk}
                        onCancel={this.cancelPaymentAsk}
                        showRemove={removeEnabled}
                        showIcon={sectionIconEnabled}
                        active={payment.active}
                        state={state}
                        fieldPrefix={fieldPrefix}
                        appComponents={this.appComponents}
                    />
                );

                // After account is validated, payment record becomes active
                // show payment info when we validated the account (payment.active)
                if (payment.active) {
                    reactElements.push(
                        <PaymentInfo
                            key={"PaymentInfo-" + payment.index}
                            idx={idx}
                            config={config}
                            showIcon={sectionIconEnabled}
                            payment={payment}
                            state={state}
                            appComponents={this.appComponents}
                        />
                    );
                }
            });

            // add another account section when all accounts are active
            if (paymentConfig.rotpOppAddAccount) {
                if (allPaymentsValidated) {
                    reactElements.push(
                        <AccountAddSection
                            key="AddAnotherAccount"
                            config={config}
                            state={state}
                            onAdd={this.addPayment}/>
                    );
                }
            }

            // add payment preference section for disaster recovery and field receipt
            if (PaymentPreferenceSection && allPaymentsValidated) {
                const enableDisasterRecovery = paymentConfig.permissionServiceCenterOverride ? JSON.parse(paymentConfig.permissionServiceCenterOverride) : false;
                reactElements.push(
                    <PaymentPreferenceSection
                        key={"PaymentPreference"}
                        config={config}
                        state={state}
                        showDisasterRecovery={enableDisasterRecovery}
                    />
                );
            }

            // add the customer section to just before the payment method section
            // add the customer section to just before the payment method section
            if (!paymentConfig.roppCxAfterPm) {
                reactElements.push(
                    <ContactInfoSection
                        key={"ContactInfo"}
                        showIcon={sectionIconEnabled}
                        config={config}
                        data={data}
                        active={hasActivePayments}
                        appComponents={this.appComponents}
                        state={state}
                    />);
            }

            // For Alfa we only consider the last used payment method based on
            // the first account, which is recorded in the paymp_header.account_number
            let lastUsedPm = data.payments.length > 0 ? data.payments[0].lastUsedPm : undefined;
            reactElements.push(
                <PaymentMethodInfo
                    key="PaymentMethod"
                    paymentMethod={data.paymentMethod}
                    active={hasActivePayments}
                    lastUsedPm={lastUsedPm}
                    showIcon={sectionIconEnabled}
                    state={state}
                    appComponents={this.appComponents}
                />
            );


            // add the customer section to after the payment method section
            if (paymentConfig.roppCxAfterPm) {
                reactElements.push(
                    <ContactInfoSection
                        key={"ContactInfo"}
                        showIcon={sectionIconEnabled}
                        config={config}
                        data={data}
                        active={hasActivePayments}
                        appComponents={this.appComponents}
                        state={state}
                    />);
            }

            reactElements.push(
                <ReviewPayment
                    key="ReviewPayment"
                    active={hasActivePayments}
                    showIcon={sectionIconEnabled}
                    state={state}
                    onCancel={this.cancelPaymentAsk}
                    appComponents={this.appComponents}
                    postProcessSuccessfulPayment={postProcessSuccessfulPayment}
                />
            );
        }

        if (data.showReceipt) {
            reactElements.push(
                <Receipt
                    key="ReceiptPage"
                    showIcon={sectionIconEnabled}
                    config={config}
                    state={state}
                    data={data}
                    setValue={setValue}
                    handleMakeNewPayment={this.makeAnotherPaymentDiffCustomer}
                    appComponents={this.appComponents}
                />
            );
        }

        // Add dialogs as needed
        if (removeDlgPayment) {
            reactElements.push(
                <DeleteDialog
                    key="RemoveDlg"
                    config={config}
                    handleAccept={this.removePaymentConfirmed.bind(null, removeDlgPayment.index)}
                    handleClose={this.closeRemoveDlg}
                />
            );
        }

        if (cancelDlgPayment) {
            reactElements.push(
                <CancelDialog
                    key="CancelDlg"
                    config={config}
                    handleAccept={this.cancelPaymentConfirmed}
                    handleClose={this.closeCancelDlg}
                />
            );
        }

        if (accountWithRecentPayments) {
            reactElements.push(
                <AcceptAccountDialog
                    key="AcceptAccountDlg"
                    config={config}
                    payment={accountWithRecentPayments}
                    handleAccept={this.acceptPayment.bind(null, accountWithRecentPayments.index)}
                    handleClose={this.acceptPaymentCancel}
                />
            );
        }

        return (
            <RoppPageWrapper
                reactElements={reactElements}
                config={config}/>
        );
    }
}

export default OnePagePayment;
